var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-tooltip',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"text":"View Detail"}},[_c('vs-button',{staticClass:"m-1",staticStyle:{"float":"left"},attrs:{"size":"small","type":"border"},on:{"click":function($event){return _vm.viewDetailHandler()}}},[_vm._v(" View")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }